// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editor-page {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #f5f5f5;
}

.editor-page-empty {
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.upload-container {
  max-width: 600px;
  padding: 40px;
}

.upload-container h1 {
  color: white;
  font-size: 42px;
  margin: 0 0 10px 0;
  text-align: center;
}

.upload-container .subtitle {
  color: rgba(255, 255, 255, 0.8);
  font-size: 18px;
  margin: 0 0 30px 0;
  text-align: center;
}

.features {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-top: 30px;
}

.feature {
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
}

.feature-icon {
  font-size: 20px;
}

/* Processing overlay */
.processing-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.processing-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.processing-overlay p {
  color: white;
  font-size: 18px;
  margin-top: 20px;
}

/* Error toast */
.error-toast {
  position: fixed;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  background: #dc3545;
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  z-index: 3000;
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    transform: translateX(-50%) translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateX(-50%) translateY(0);
    opacity: 1;
  }
}

/* Fullscreen mode */
.editor-page:-webkit-full-screen,
.editor-page:-moz-full-screen,
.editor-page:-ms-fullscreen,
.editor-page:fullscreen {
  height: 100vh;
  width: 100vw;
}

.editor-page:-webkit-full-screen {
  height: 100vh;
}

`, "",{"version":3,"sources":["webpack://./src/ui/pages/EditorPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,6DAA6D;AAC/D;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,yCAAyC;EACzC,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE;IACE,4CAA4C;IAC5C,UAAU;EACZ;EACA;IACE,yCAAyC;IACzC,UAAU;EACZ;AACF;;AAEA,oBAAoB;AACpB;;;;EAIE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;AACf","sourcesContent":[".editor-page {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100vh;\r\n  background: #f5f5f5;\r\n}\r\n\r\n.editor-page-empty {\r\n  justify-content: center;\r\n  align-items: center;\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n}\r\n\r\n.upload-container {\r\n  max-width: 600px;\r\n  padding: 40px;\r\n}\r\n\r\n.upload-container h1 {\r\n  color: white;\r\n  font-size: 42px;\r\n  margin: 0 0 10px 0;\r\n  text-align: center;\r\n}\r\n\r\n.upload-container .subtitle {\r\n  color: rgba(255, 255, 255, 0.8);\r\n  font-size: 18px;\r\n  margin: 0 0 30px 0;\r\n  text-align: center;\r\n}\r\n\r\n.features {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 30px;\r\n  margin-top: 30px;\r\n}\r\n\r\n.feature {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  color: rgba(255, 255, 255, 0.9);\r\n  font-size: 14px;\r\n}\r\n\r\n.feature-icon {\r\n  font-size: 20px;\r\n}\r\n\r\n/* Processing overlay */\r\n.processing-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 2000;\r\n}\r\n\r\n.processing-spinner {\r\n  width: 50px;\r\n  height: 50px;\r\n  border: 4px solid rgba(255, 255, 255, 0.3);\r\n  border-top-color: white;\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.processing-overlay p {\r\n  color: white;\r\n  font-size: 18px;\r\n  margin-top: 20px;\r\n}\r\n\r\n/* Error toast */\r\n.error-toast {\r\n  position: fixed;\r\n  bottom: 30px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  background: #dc3545;\r\n  color: white;\r\n  padding: 12px 24px;\r\n  border-radius: 8px;\r\n  font-size: 14px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\r\n  z-index: 3000;\r\n  animation: slideUp 0.3s ease;\r\n}\r\n\r\n@keyframes slideUp {\r\n  from {\r\n    transform: translateX(-50%) translateY(20px);\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    transform: translateX(-50%) translateY(0);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n/* Fullscreen mode */\r\n.editor-page:-webkit-full-screen,\r\n.editor-page:-moz-full-screen,\r\n.editor-page:-ms-fullscreen,\r\n.editor-page:fullscreen {\r\n  height: 100vh;\r\n  width: 100vw;\r\n}\r\n\r\n.editor-page:-webkit-full-screen {\r\n  height: 100vh;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
